var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolFlipHorizontal = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M10.632 7.316H6a2 2 0 0 0-2 2v9.263a2 2 0 0 0 2 2h4.632"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeDasharray: "1,3.1",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M18.368 7.316H23a2 2 0 0 1 2 2v9.263a2 2 0 0 1-2 2h-4.632 0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M14.5 4.553v18.789"
}))));
export { SvgToolFlipHorizontal as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-flip-horizontal.svg";